import { IdentityDto } from './identity.dto';
import { AccountType } from '@nx-ws/bhn-enums/account/type.enum';
import { CategoryType } from '@nx-ws/bhn-enums/account/category.enum';

export class PartyDto {
  identity = new IdentityDto();
  role: AccountType;
  account: string;
  covered: boolean;
  category: CategoryType;
  biller: string;
  isBhnParty = true;

  constructor(d?: PartyDto) {
    if (!d) {
      return;
    }
    this.identity = new IdentityDto(d.identity);
    this.role = d.role;
    this.account = d.account;
    this.covered = d.covered;
    this.category = d.category;
    this.biller = d.biller;
    this.isBhnParty = d.isBhnParty;
  }
}
